import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./welcome.css";

export default function Welcome() {
  const { data: themeData } = useSelector((s) => s.theme);
  const textColor = themeData?.text_color || "#000000";
  const wordMode =
    String(themeData?.submission_mode || "").trim().toLowerCase() === "word";

  return (
    <div className="welcome-page" style={{ color: textColor }}>
      <h1 className="welcome-title">
        {wordMode
          ? "Thank you for sharing your word!"
          : "Thank you for uploading your photo!"}
      </h1>
      <h2 className="welcome-subtitle">It will be featured in our mosaic.</h2>
      <p className="welcome-link-text">
        <Link to="/game" className="welcome-link" style={{ color: textColor }}>
          Click here
        </Link>{" "}
        to see the mosaic.
      </p>
    </div>
  );
}
